<script>
import { Line } from 'vue-chartjs'
export default {
  extends: Line,
  props: ['data', 'options'],
  mounted () {
  },
  watch: {
    data: function (val) {
      this.renderChart(this.data, this.options)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/home/AggregateChart.vue